<template lang="pug">
  v-dialog(:value="value" @input="close" max-width="600")
    v-card
      validation-observer(ref="obs" v-slot="{ handleSubmit }")
        v-form(ref="form")
          v-card-title.headline.mb-4.ml-1 Добавить вопрос
            v-spacer
            v-btn(@click="close" icon)
              v-icon mdi-close
          v-card-text
            validation-provider(
              rules="required"
              name="Вопрос"
              vid="title"
              v-slot="{ errors, valid }"
            )
              v-text-field(
                v-model="question.question"
                :error-messages="errors"
                label="Вопрос"
                rounded filled
              )

            validation-provider(
              rules="required"
              name="Ответ"
              vid="answer"
              v-slot="{ errors, valid }"
            )
              v-textarea(
                v-model="question.answer"
                :error-messages="errors"
                label="Ответ"
                rounded filled
              )

            validation-provider(
              rules="required"
              name="Категория"
              vid="faq_category_id"
              v-slot="{ errors, valid }"
            )
              v-select(
                :items="categories"
                item-text="name"
                item-value="id"
                v-model="question.faq_category_id"
                :error-messages="errors"
                label="Категория"
                rounded filled
              )

          v-card-actions
            v-spacer
            v-btn(@click="close" color="warning" rounded text) Отмена
            v-btn(
              v-if="!question.id"
              @click="handleSubmit(createQuestion)"
              :loading="btnLoading"
              color="success"
              rounded text
            ) Добавить
            v-btn(
              v-if="question.id"
              @click="handleSubmit(updateQuestion)"
              :loading="btnLoading"
              color="success"
              rounded text
            ) Изменить
</template>

<script>
export default {
  name: 'CreateQuestionDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    question: {
      type: Object,
      default: () => ({}),
    },
    categories: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    btnLoading: false,
    categoriesLoading: false,
  }),
  methods: {
    createQuestion() {
      this.btnLoading = true;
      this.$rHandler(
        this.$api.faq.questions.create(this.question),
        (r) => {
          this.btnLoading = false;
          this.close();
          this.$toasted.success('Вопрос успешно добавлен', { duration: 3000 });

          this.$emit('question:add', { ...this.question, id: r.data.data });
        },
        () => {},
        this.$refs.obs,
      );
    },
    updateQuestion() {
      this.btnLoading = true;
      this.$rHandler(
        this.$api.faq.questions.update(this.question.id, this.question),
        () => {
          this.btnLoading = false;
          this.close();
          this.$toasted.success('Вопрос успешно изменен', { duration: 3000 });
          this.$emit('question:update');
        },
        () => {},
        this.$refs.obs,
      );
    },
    close() {
      this.$emit('input', false);
      this.$refs.obs.reset();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
